import { toTimePeriod, getUnixTimestampDisplayString } from 'util/date'
import List from '../shared/List'
import ContentCard from '../shared/ContentCard'

const statusProps = {
  trialing: { textColor: 'groovy', text: 'Trial' },
  active: { textColor: 'groovy', text: 'Active' },
  past_due: { textColor: 'berry', text: 'Past due' },
  canceled: { textColor: 'berry', text: 'Cancelled' },
  unpaid: { textColor: 'berry', text: 'Unpaid' },
}

const Subscriptions = ({ subscriptions, subscriptionUrls }) => (
  <div>
    {subscriptions.map(
      ({
        created,
        id,
        status,
        plan,
        quantity,
        discount,
        current_period_end: currentPeriodEnd,
        cancel_at_period_end: cancelAtPeriodEnd,
      }) => (
        <ContentCard title={plan.product.name} key={id}>
          <List.Container>
            {id && (
              <List.Item label="ID">
                {subscriptionUrls ? (
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={subscriptionUrls[id]}
                  >
                    {id}
                  </a>
                ) : (
                  id
                )}
              </List.Item>
            )}
            {created && (
              <List.Item label="Subscribed">
                {getUnixTimestampDisplayString(created)}
              </List.Item>
            )}
            {status && (
              <List.Item
                {...{
                  ...statusProps[status],
                  label: 'Status',
                }}
              >
                {status}
              </List.Item>
            )}
            {plan.nickname && (
              <List.Item label="Plan name">{plan.nickname}</List.Item>
            )}
            {plan.interval && (
              <List.Item label="Billing cycle">
                {toTimePeriod(plan.interval)}
              </List.Item>
            )}
            {discount && <List.Item label="Discount">{discount}</List.Item>}
            {quantity && (
              <List.Item label="Number of plans">{quantity}</List.Item>
            )}
            {currentPeriodEnd && (
              <List.Item label="Next bill date">
                {getUnixTimestampDisplayString(currentPeriodEnd)}
              </List.Item>
            )}
            <List.Item label="Set to cancel">
              {`${!!cancelAtPeriodEnd}`}
            </List.Item>
          </List.Container>
        </ContentCard>
      )
    )}
  </div>
)

export default Subscriptions
